import { Component, input } from '@angular/core';
import { WinCardFifthVariantConfig } from '@shared/models';
import { RewardPipe, TransformUrlToBgPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant5',
  styleUrl: './variant5.component.scss',
  templateUrl: './variant5.component.html',
  imports: [RewardPipe, TransformUrlToBgPipe],
})
export class Variant5Component {
  amount = input<number>(0);
  config = input.required<WinCardFifthVariantConfig>();
}
